<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'"
  (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="page-contents">
  <div class="subBlockContainer" id='levelTwo'>
    <div class="subBlockContent" id="windows-11-report-extract">
      <child-header title="Windows 11 Report Extract" (closeEvent)="close()"></child-header>
      <app-windows-11-report-top></app-windows-11-report-top>
      <div class="report-panel-wrapper">
      <div class="report-panel">
        <mat-accordion [multi]="true" >
          <mat-expansion-panel [expanded]="true" #panel1 *ngIf="hasEligibilityGroup('2')">
            <mat-expansion-panel-header class="custom-header dd-red">
              <mat-panel-title  style="justify-content:center;">Not Compatible with Windows 11</mat-panel-title>
              <span style="margin-left: auto;">
                <span *ngIf="!panel1.expanded" class="icon-expand"></span>
                <span *ngIf="panel1.expanded" class="icon-collapse"></span>
              </span>
            </mat-expansion-panel-header>
            <div class="table-header">
              <div class="table-cell">Device ID</div>
              <div class="table-cell">OSVersion</div>
              <div class="table-cell">Reason</div>
            </div>
            <div *ngFor="let row of getByEligibilityGroup('2')" class="table-row">
              <div class="table-cell">{{ row.DeviceName }}</div>
              <div class="table-cell">{{ row.OSVersion }}</div>
              <div class="table-cell">{{ row.Reason }}</div>
            </div>
            <button mat-raised-button class="section-button button-red">Act Now</button>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true" #panel2 *ngIf="hasEligibilityGroup('1')">
            <mat-expansion-panel-header class="custom-header report-orange">
              <mat-panel-title style="justify-content:center;">Further Investigation Required</mat-panel-title>
              <span style="margin-left: auto;">
                <span *ngIf="!panel2.expanded" class="icon-expand"></span>
                <span *ngIf="panel2.expanded" class="icon-collapse"></span>
              </span>
            </mat-expansion-panel-header>
            <div class="table-header">
              <div class="table-cell">Device ID</div>
              <div class="table-cell">OSVersion</div>
              <div class="table-cell">Reason</div>
            </div>

            <div *ngFor="let row of getByEligibilityGroup('1')" class="table-row">
              <div class="table-cell">{{ row.DeviceName }}</div>
              <div class="table-cell">{{ row.OSVersion }}</div>
              <div class="table-cell">{{ row.Reason }}</div>
            </div>

            <button mat-raised-button class="section-button button-grey">Learn More</button>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true" #panel3 *ngIf="hasEligibilityGroup('3')">
            <mat-expansion-panel-header class="custom-header report-light-green">
              <mat-panel-title style="justify-content:center;">Compatible to Upgrade to Windows 11</mat-panel-title>
              <span style="margin-left: auto;">
                <span *ngIf="!panel3.expanded" class="icon-expand"></span>
                <span *ngIf="panel3.expanded" class="icon-collapse"></span>
              </span>
            </mat-expansion-panel-header>
            <div class="table-header">
              <div class="table-cell">Device ID</div>
              <div class="table-cell">OSVersion</div>
              <div class="table-cell">Reason</div>
            </div>
            <div *ngFor="let row of getByEligibilityGroup('3')" class="table-row">
              <div class="table-cell">{{ row.DeviceName }}</div>
              <div class="table-cell">{{ row.OSVersion }}</div>
              <div class="table-cell">{{ row.Reason }}</div>
            </div>

            <button mat-raised-button class="section-button button-grey">Upgrade to Windows 11</button>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true" #panel4 *ngIf="hasEligibilityGroup('0')">
            <mat-expansion-panel-header class="custom-header report-green">
              <mat-panel-title style="justify-content:center;">Devices already on Windows 11 - Congratulations!</mat-panel-title>
              <span style="margin-left: auto;">
                <span *ngIf="!panel4.expanded" class="icon-expand"></span>
                <span *ngIf="panel4.expanded" class="icon-collapse"></span>
              </span>
            </mat-expansion-panel-header>
            <div class="table-header">
              <div class="table-cell">Device ID</div>
              <div class="table-cell">OSVersion</div>
              <div class="table-cell">Reason</div>
            </div>
            <div *ngFor="let row of getByEligibilityGroup('0')" class="table-row">
              <div class="table-cell">{{ row.DeviceName }}</div>
              <div class="table-cell">{{ row.OSVersion }}</div>
              <div class="table-cell">{{ row.Reason }}</div>
            </div>
            <button mat-raised-button class="section-button button-grey" style="width: 330px !important;">Explore Copilot+ PCs and Copilot Licenses</button>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
    </div>
  </div>